module.exports = __webpack_public_path__ + "static/Pt100-2-ec6897e19c04748815f25c4bb84f794a.jpg";